import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import Utils from '../../../utils/utils';

const TEXT = [
  `Specific comments varied across reports, with a range of scores from 1 to 8. Themes such as consistency, technical development, and communication skills were recurring points of feedback. It is evident that the student has shown growth and potential throughout the internship, with areas for further development identified by supervisors.`,
  `**Average Score: 5.5**`,
  `The average score based on the submitted Workplace Learning Reports is 5.4`,
  `The average of the scores provided in the Workplace Learning Reports is 5.4`,
  `The average score of the submitted Workplace Learning Reports is 5.4 If you need further details or insights on specific scores, feel free to ask!`,
  `The average score of Karim is 9.5.`,
  `The average score of all submitted Workplace Learning Reports is 8.5.`,
  `The intern, Faisal STD 1, has shown consistent growth and dedication throughout the internship at HolyC. Initially adapting to the new environment, Faisal quickly progressed in technical development, problem-solving, and communication skills. He faced challenges with project requirements and technical gaps but demonstrated resilience by seeking guidance, learning from errors, and improving task deliveries. Faisal's reflections emphasized adaptability, proactive engagement, and continuous learning for professional development. Overall, Faisal has exhibited significant improvement in technical abilities, problem-solving skills, and a clear focus on writing cleaner, maintainable code for future scalability. His trajectory shows a promising potential for future roles, particularly in enhancing JavaScript proficiency and exploring advanced optimization techniques for web applications.`,
  `
# Heading 1
## Heading 2
The quick brown fox jumps over the lazy dogs.
1. One
1. Two
1. Three
***
Abc.
The intern, Faisal STD 1, has shown consistent growth and dedication throughout the internship at HolyC. Initially adapting to the new environment, Faisal quickly progressed in technical development, problem-solving, and communication skills. He faced challenges with project requirements and technical gaps but demonstrated resilience by seeking guidance, learning from errors, and improving task deliveries. Faisal's reflections emphasized adaptability, proactive engagement, and continuous learning for professional development. Overall, Faisal has exhibited significant improvement in technical abilities, problem-solving skills, and a clear focus on writing cleaner, maintainable code for future scalability. His trajectory shows a promising potential for future roles, particularly in enhancing JavaScript proficiency and exploring advanced optimization techniques for web applications.
***
* abc
  * abc.abc
* def
* ghij
lol
🗿🗿🗿
  `
];

export default function RefMarkdown() {
  const memoized = useMemo(() => {
    return <>
      {TEXT.filter(t => t !== "").map((text, i) => <div key={i} className='alert alert-info ref-markdown'>
        <ReactMarkdown>{Utils.dotToNewlines(text.trim())}</ReactMarkdown>
      </div>)}
    </>;
  }, []);

  return <>
    <style>{`
      .ref-markdown p:last-child {
        margin-bottom: 0;
      }
    `}</style>
    {memoized}
  </>;
}
